import React, { useState, useEffect } from 'react';
import './Footer.css';
import { motion, AnimatePresence } from 'framer-motion';
import {
  FaPhoneAlt, FaEnvelope, FaFacebookF, FaTwitter,
  FaLinkedinIn, FaInstagram, FaClock, FaMapMarkerAlt,
  FaGraduationCap, FaUserGraduate, FaAward, FaGlobe,
  FaChartLine, FaRocket, FaCertificate
} from 'react-icons/fa';
import { Link } from 'react-router-dom'; // ✅ required


export const Footer = () => {
  const [currentTime, setCurrentTime] = useState(new Date());
  const [activeTab, setActiveTab] = useState(0);
  const [hoverStats, setHoverStats] = useState(null);
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => setCurrentTime(new Date()), 1000);
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);

    return () => {
      clearInterval(timer);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const stats = [
    { icon: <FaUserGraduate />, count: 5000, label: 'Graduates', plus: true },
    { icon: <FaChartLine />, count: 98, label: 'Placement Rate', suffix: '%' },
    { icon: <FaAward />, count: 15, label: 'Years Experience', plus: true },
    { icon: <FaCertificate />, count: 25, label: 'Certifications', plus: true }
  ];

  const courses = [
    {
      name: 'SAP FICO',
      rating: 4.9,
      enrolled: 1200,
      nextBatch: '2025-08-01',
      tag: 'Popular'
    },
    {
      name: 'SAP MM',
      rating: 4.8,
      enrolled: 950,
      nextBatch: '2025-07-25',
      tag: 'New'
    },
    {
      name: 'SAP SD',
      rating: 4.7,
      enrolled: 850,
      nextBatch: '2025-08-10',
      tag: 'Trending'
    }
  ];

  return (
    <>

    <footer className="footer-premium position-relative overlay-top">
      <div className="footer-top">
        <div className="brand-section">
          <div className="logo-container">
            <img
  src="/assets/img/lg.png"
  alt="RAMESH ENTERPRISES"
  className="logo"
  style={{ width: "80px", height: "auto" }}
/>

            <div
              className="logo-glow"
              animate={{
                scale: [1, 1.2, 1],
                opacity: [0.5, 0.8, 0.5]
              }}
              transition={{
                duration: 2,
                repeat: Infinity,
                ease: "easeInOut"
              }}
            />
          </div>

          <div
            className="brand-description"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3 }}
          >
            <h2>RAMESH ENTERPRISES</h2>
         <p>With 35+ years of legacy, PTP Group (Precision Telecom Products & Ramesh Enterprises) continues to grow.</p>

          </div>
          
          
        </div>
        <div className="Quick-links">
  <p>Quick Links</p>
  <Link to="/">Home</Link>
  <Link to="/about">About</Link>
  <Link to="/blog">Buy From Us</Link>
  {/* <Link to="/Sells">Supply to Us</Link> */}
</div>

<div className="Course-links">
  <p>Quick Links</p>
    <Link to="/careers">Careers</Link>
  <Link to="/contact">Contact</Link>
      <Link to="/Sells">Supply to Us</Link>
</div>

        <div
          className="link-contact-section"
        >


          <div className="social-links">
            {[FaFacebookF, FaTwitter, FaLinkedinIn, FaInstagram].map((Icon, index) => (
              <a
                key={index}
                href="#"
                className="social-icon"
              >
                <Icon />
              </a>
            ))}
          </div>

          <div
            className="map-container"
            whileHover={{ scale: 1.02 }}
          >
           
            <iframe
  src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d230.9539418029724!2d77.6990517066043!3d12.99618872929837!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e1!3m2!1sen!2sin!4v1753168961803!5m2!1sen!2sin"
  width="100%"
  height="200"
  style={{ border: 0 }}
  allowFullScreen
  loading="lazy"
  referrerPolicy="no-referrer-when-downgrade"
  
/>

          </div>
        </div>
      </div>



      {/* Footer Bottom */}
      <div
        className="footer-bottom"

      >

        <div
          className="copyright"
          whileHover={{ scale: 1.05 }}
        >
          © {currentTime.getFullYear()}RAMESH ENTERPRISES. All rights reserved.
        </div>
        <div className="bottom-links">
          {['Privacy Policy', 'Terms of Service', 'Support'].map((text, index) => (
            <a
              key={index}
              href="#"
              whileHover={{
                scale: 1.1,
                color: "white"
              }}
            >
              {text}
            </a>
          ))}
        </div>
<div>
  <a href="https://excerptech.com/" target="_blank" rel="noopener noreferrer">
    <h6>
      Powered by Excerpt Technologies
      <FaGlobe style={{ marginLeft: '15px' }} />
    </h6>
  </a>
</div>
      </div>
    </footer></>
  );
};